import { useEffect, useRef, useState } from 'react';

const fotos = [
  {
    src: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/419edaa7-3e65-4331-bf8a-e5f22a20a5a0_20251110_093549.jpg?v=02dd667a133b819e8476cf4fd9c9681a',
    alt: 'Momento especial – Escola Infantil Turminha da Alegria Campinas',
    span: 'lg:col-span-2 lg:row-span-2',
    h: 'h-64 lg:h-full',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/639d5130-6949-4e1f-8b41-a2c47c9d71fa_20251110_094100.jpg?v=f7cb1a649c979f080e2fd5343b9765f5',
    alt: 'Crianças na escola infantil em Campinas',
    span: '',
    h: 'h-48',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/48d09e27-e604-4a11-8ccc-4af4e316bfdd_20251110_094257.jpg?v=52cbf1b5cf8a42781f1b3df0f61cce62',
    alt: 'Atividades lúdicas – Turminha da Alegria',
    span: '',
    h: 'h-48',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/f6b15bb9-0a9f-496b-9ad9-42176d58e2ec/74201e2e-3840-4845-8693-29b88ff1a109_20251110_094442.jpg?v=36a16fda8d492ad145408a053dc7e5d6',
    alt: 'Educação infantil Campinas – Escola Turminha da Alegria',
    span: '',
    h: 'h-48',
  },
];

export default function Galeria() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="galeria" className="py-24 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block bg-vermelho/10 text-vermelho font-body font-700 text-sm px-4 py-1.5 rounded-full mb-4">
            Galeria
          </span>
          <h4 id="galeria-section">
            <a className="font-heading text-[#0D0D0D] text-3xl lg:text-4xl block">
              Momentos especiais na escola
            </a>
          </h4>
          <p className="font-body text-gray-500 text-base mt-4 max-w-xl mx-auto">
            Um pequeno glimpse do dia a dia alegre e cheio de aprendizado da nossa escola infantil em Campinas.
          </p>
        </div>

        <div
          className={`grid grid-cols-2 lg:grid-cols-4 gap-4 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {fotos.map((foto, i) => (
            <div
              key={i}
              className={`${foto.span} overflow-hidden rounded-3xl ${foto.h} group cursor-pointer`}
            >
              <img
                src={foto.src}
                alt={foto.alt}
                title={foto.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ objectPosition: 'center 60%' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
